import { Controller } from "@hotwired/stimulus"
import Sortable from "sortablejs"
import { post } from "@rails/request.js";

export default class extends Controller {
  static targets = ["list"]

  static values = {
    sortableUrl: String,
  }

  connect() {
    this.initializeSortable()
  }

  initializeSortable() {
    if (this.hasListTarget) {
      this.sortable = Sortable.create(this.listTarget, {
        animation: 150,
        handle: '.drag-handle',
        ghostClass: 'sortable-ghost',
        onEnd: this.handleSortEnd.bind(this)
      })
    }
  }

  handleSortEnd(event) {
    const { newIndex, item } = event;
    post(this.sortableUrlValue, {
      body: JSON.stringify({ position: newIndex + 1, id: item.dataset.questionId}),
      responseKind: "turbo-stream"
    });
  }

  // §04 callout → the checkout-type setting (same Settings page). Smooth-scroll
  // to the type-selection cards and briefly highlight them so the organizer sees
  // the control that drives the per-attendee/per-order collection model.
  scrollToCheckoutType(event) {
    event.preventDefault()
    const target = document.getElementById("questions_checkout_type")
    if (!target) return
    target.scrollIntoView({ behavior: "smooth", block: "start" })
    target.classList.add("checkout-type-flash")
    setTimeout(() => target.classList.remove("checkout-type-flash"), 1600)
  }

  disconnect() {
    if (this.sortable) {
      this.sortable.destroy()
    }
  }
}

